import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { SenaryParagraphHeading } from 'components/Headings';
import Label from 'components/Label';
import Theme from 'styles/theme';

const Link = ({ label, href, onClick, isBold, isDropdownLink, isSalesColor, ...otherProps }) => (
  <a
    onClick={onClick}
    href={href}
    className={classNames('Link', {
      'Link--bold': isBold,
      'Link--red-color': isSalesColor,
      'Link--underline': !isDropdownLink,
    })}
    {...otherProps}
  >
    {isBold ? (
      <SenaryParagraphHeading className="Link__heading-label">{label}</SenaryParagraphHeading>
    ) : (
      <Label className="Link__label">{label}</Label>
    )}
    <style jsx>
      {`
        .Link {
          text-decoration: none;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          border: 0;
          outline: 0;
          padding: ${Theme.get('spacing') * 2}px ${Theme.get('spacing') * 6}px;
          cursor: pointer;
        }

        .Link--underline {
          padding: ${Theme.get('spacing') * 3}px ${Theme.get('spacing') * 6}px;
          border-bottom: solid 1px ${Theme.get('colors-black-20')};
        }

        .Link.focused {
          outline: 2px solid ${Theme.get('colors-black')};
        }
      `}
    </style>
    <style jsx global>
      {`
        .Link--red-color .Link__label,
        .Link--red-color .Link__heading-label {
          color: ${Theme.get('colors-discount-red')};
        }
      `}
    </style>
  </a>
);

Link.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  href: PropTypes.string.isRequired,
  isBold: PropTypes.bool,
  isSalesColor: PropTypes.bool,
  isDropdownLink: PropTypes.bool,
};

Link.defaultProps = {
  isBold: false,
  isSalesColor: false,
  isDropdownLink: false,
};

export default Link;
